<div [tsLoadingOverlay]="(isLoading$ | async) || (isDownloadInProcess$ | async)">
  <ms-analytics-filters (applyFilters)="applyFilters($event)"
                         (changeSelectedDateCohort)="changeSelectedDateCohort($event)"
                         [selectedDateCohort]="selectedDateCohort$ | async"
                         [modelTypeOptions]="modelTypeOptions$ | async"
                         [dateCohortOptions]="dateCohortOptions$ | async"
                         [filters]="filters$ | async">
  </ms-analytics-filters>
  <hr class="report-divider">
  <tsh-report-tabs [tabs]="tabs$ | async"></tsh-report-tabs>

  <router-outlet></router-outlet>
</div>
